import React from 'react'
import dynamic from 'next/dynamic'

import { useResponsive } from '@dustin-web/microsite-components/src/hooks'

const HeaderMobile = dynamic(() => import('./header-mobile'))
const HeaderDesktop = dynamic(() => import('./header-desktop'))

export default function Header() {
  const { isSmallScreen } = useResponsive()

  return isSmallScreen ? <HeaderMobile /> : <HeaderDesktop />
}
